import { createContext } from "react";
import type DialogContextType from "../types/contexts/DialogContextType";

export const DialogContext = createContext<DialogContextType | null>(null);
